import React, { useEffect, useState, useRef, VFC, ChangeEvent, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import './addNewUser.scss';
import AddWhiteIcon from '@/assets/steam/add-white.png';
import ArrowIcon from '@/assets/steam/arrow-r.svg';
import CloseIcon from '@/assets/steam/close.svg'
import { showNotification } from '@/utils/notificationUtils';
import DatePicker, { DayValue, DayRange, Day } from 'react-modern-calendar-datepicker';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import moment from 'moment';
import { useAuth } from '@/lib/auth';
import Utils from '@/utils/util';
import { User } from '@/types';
import 'react-phone-input-2/lib/style.css'; // You may need to import the stylesheet as well
import PhoneInput from 'react-phone-input-2';
import { default as ReactSelect, components } from 'react-select';
import { PageHeader } from '@/components/PageHeaders/PageHeader';
import { City, State } from '../types/indes';
import Dropdown from 'react-bootstrap/Dropdown';
import { useGetCityList, useGetManagerList } from '../api/getRefrences';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useUserMutation } from '../api/addUser';
import { ModalFooter } from 'react-bootstrap';
import { SelectedManagers } from './SelectedManagers';

const AddNewUser: VFC<{
    onConfirm: () => void;
    onClose: () => void;
    open: boolean;
    states?: any;
    role?: any;
    editUserData?: any;
}> = ({ onClose, onConfirm, open, states, role, editUserData }) => {
    const { user } = useAuth();
    const [selectedCity, setSelectedCity] = useState<State[]>();
    const [selectedRole, setSelectedRole] = useState<any>()
    const [phone, setPhone] = useState('');
    const [userData, setUserData] = useState<User>({
        name: '',
        email: '',
        userRoleId: '',
    } as User);
    const useGetCityMutation = useGetCityList();
    const useUserMutations = useUserMutation();
    const useGetManagerMutation = useGetManagerList();
    const [managers, setManagers] = useState<User[]>([]);
    const [city, setCity] = useState<City[]>([]);
    const [selectedLocationDetails, setSelectedLocationDetails] = useState<any[]>([]);
    const [locationDetails, setLocationDetails] = useState<any>({
        state: '',
        city: [],
        stateId: ''
    });
    const [selectedManager, setSelectedManager] = useState<User[]>();
    const [selectedSubords, setSelectedSubords] = useState<User[]>();
    useEffect(() => {

        if (editUserData) {

            setUserData({
                name: editUserData?.name,
                email: editUserData?.email,
                userRoleId: '',
            } as User)

            setSelectedRole(editUserData?.userRole?.name)
            getManagerList(editUserData?.userRole?.id)
            setPhone(editUserData?.phone)
            if (editUserData?.senior && editUserData.senior.length > 0) {
                const selectedMembers = editUserData.senior
                    .filter((item: any) => item?.seniorDetail)
                    .map((item: any) => ({
                        id: item.seniorDetail.id,
                        name: item.seniorDetail.name,
                        email: item.seniorDetail.email,
                        userRoleId: item.seniorDetail.userRoleId,
                    }));

                setSelectedManager(selectedMembers);
            }
            if (editUserData?.subord && editUserData.subord.length > 0) {

                const selectedMembers = editUserData.subord.filter((item: any) => item?.subordDetail).map((item: any) => ({
                    "id": item?.subordDetail?.id,
                    "name": item?.subordDetail?.name,
                    "email": item.subordDetail?.email,
                    "userRoleId": item?.subordDetail?.userRoleId

                }))
                setSelectedSubords(selectedMembers)
            }

            if (editUserData?.location && editUserData.location.length > 0) {

                transformLocation(editUserData?.location);
            }

        }

    }, [editUserData])

    const transformLocation = (locations: any) => {
        const transformedLocations: any = [];

        locations.forEach((location: any) => {
            const existingState = transformedLocations.find(
                (stateObj: any) => stateObj.stateId === location.state.id
            );

            if (existingState) {
                existingState.city.push({ id: location.city.id, name: location.city.name });
            } else {
                transformedLocations.push({
                    state: location.state.name,
                    stateId: location.state.id,
                    city: [{ id: location.city.id, name: location.city.name }]
                });
            }
        });

        setSelectedLocationDetails(transformedLocations)
    }
    const validate = () => {

        let errorMessage = '';
        if (
            !userData?.email ||
            userData?.email.trim().length < 1 ||
            !Utils.isValidEmail(userData?.email)
        ) {
            errorMessage = 'Please enter valid email';
        } else if (!userData?.name) {
            errorMessage = 'Please enter name';
        } else if (!phone) {
            errorMessage = 'Please enter phone';
        } else if (!selectedRole) {
            errorMessage = 'Please select role';
        } else if (selectedRole && (selectedRole === 'Sales Manager' || selectedRole === 'Sales Executive' || selectedRole === 'Sales Head') && selectedLocationDetails && selectedLocationDetails.length === 0) {
            errorMessage = 'Please add atleast 1 state and city';
        }
        // else if (editUserData && (selectedRole !== editUserData?.userRole?.name) && selectedSubords && selectedSubords.length > 0) {
        //     errorMessage = 'Please remove the reportee users before changing the role';
        // } else if (editUserData && (selectedRole !== editUserData?.userRole?.name) && selectedManager && selectedManager.length > 0) {
        //     errorMessage = 'Please remove the reportee users before changing the role';
        // }
        if (errorMessage) {
            showNotification({
                type: 'info',
                title: errorMessage,
            });
            return false;
        }
        return true;
    };

    const handleChangeEmail = async (event: ChangeEvent<HTMLInputElement>) => {
        userData.email = event.target.value;
        if (Utils.isValidEmail(userData?.email)) {
            setUserData({ ...userData });
        }
        setUserData({ ...userData });
    };

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.id === 'name') {
            userData.name = event.target.value;
        } else if (event.target.id === 'phone') {
            userData.phone = event.target.value;
        }
        setUserData({ ...userData });
    };

    const getCityList = async (id: any) => {
        const res = await useGetCityMutation.mutateAsync({ id });
        if (res) {

            setCity(res.list);
        }
    };

    const getManagerList = async (id: any) => {
        const res = await useGetManagerMutation.mutateAsync({
            id
        });
        if (res) {

            setManagers(res.list);
        }
    };

    const addCityAndState = () => {
        if (locationDetails?.state && selectedCity && selectedCity.length > 0) {
            const details = {
                state: locationDetails?.state,
                stateId: locationDetails?.stateId,
                city: selectedCity
            }
            const updatedLocationDetails = [...selectedLocationDetails, details]; // Spread the existing array and add the new details
            setSelectedLocationDetails(updatedLocationDetails);
            setCity([]);
            setSelectedCity([]);
            setLocationDetails({
                state: '',
                city: [],
                stateId: ''
            })
        } else {
            showNotification({
                type: 'info',
                title: 'Please select atleast one city.',
            });
        }


    }

    const deleteState = (stateName: any) => {
        if (selectedLocationDetails && selectedLocationDetails.length > 0) {
            const locations = selectedLocationDetails.filter((item: any) => item.state !== stateName)
            setSelectedLocationDetails(locations);
        }
    }

    const deleteCity = (cityId: any) => {
        if (selectedLocationDetails && selectedLocationDetails.length > 0) {
            const updatedLocations = selectedLocationDetails.map((location: any) => {
                return {
                    ...location,
                    city: location.city.filter((city: any) => city.id !== cityId)
                };
            });
            setSelectedLocationDetails(updatedLocations);
        }
    }


    const resetStates = () => {
        setCity([]);
        setPhone('')
        setSelectedCity([]);
        setSelectedSubords([]);
        setLocationDetails({
            state: '',
            city: [],
            stateId: ''
        })
        setSelectedLocationDetails([]);
        setSelectedRole('');
        setSelectedManager([]);
        setManagers([])
        setLocationDetails({
            state: '',
            city: [],
            stateId: ''
        });
        setUserData({
            name: '',
            email: '',
            userRoleId: '',
        } as User);

    }

    const removeProvider = (provider: any) => {
        const filteredIndex = selectedManager?.findIndex((sp) => {
            return sp.id === provider.id;
        });
        if (filteredIndex != undefined && filteredIndex >= 0) {
            selectedManager?.splice(filteredIndex, 1);
            setSelectedManager([...selectedManager as User[]]);
        }
    };
    const removeProvider1 = (provider: any) => {
        // const filteredIndex = selectedManager?.findIndex((sp) => {
        //     return sp.id === provider.id;
        // });
        // if (filteredIndex != undefined && filteredIndex >= 0) {
        //     selectedManager?.splice(filteredIndex, 1);
        //     setSelectedManager([...selectedManager as User[]]);
        // }
    };

    const CheckOldManagersAvailable = (userId: any) => {
        const check = selectedManager?.length && selectedManager?.filter((item: any) => { Number(item?.userRoleId) !== Number(userId) })

        if (check && check.length === 0) {
            return true
        } else {
            return false
        }

    }

    const showRole = selectedRole === 'Sales Manager' ? false : selectedRole === 'Sales Head' ? false : true;
    const getContent = () => {
        return (
            <div className="add-user-content">
                <div className="user-container">
                    <h1>
                        Basic Details <span>*</span>
                    </h1>
                    <div className='user-first-last-div'>
                        <input
                            className={`custome-input width-50`}
                            placeholder={'Name'}
                            onChange={handleChange}
                            value={userData?.name}
                            id="name"
                        />
                        <div className="new-figma-phone">
                            <PhoneInput
                                placeholder="phone no"
                                value={phone}
                                onChange={setPhone}
                                country={'in'}
                                countryCodeEditable={false}
                            />
                        </div>
                    </div>
                    {/* <div className="new-figma-phone">
                        <PhoneInput
                            placeholder="phone no"
                            value={phone}
                            onChange={setPhone}
                            country={'in'}
                            countryCodeEditable={false}
                        />
                    </div> */}
                    <input
                        className={`custome-input`}
                        placeholder={'Email'}
                        onChange={handleChangeEmail}
                        value={userData?.email}
                        id="email"
                    />
                    <div className='note'>This email address will be used for further communication</div>

                    <Dropdown className="new-figma-drop-down">
                        <Dropdown.Toggle
                            variant="success"
                            className="drop-down-btn fixed-width dropdown-toggle"
                            id="dropdown-basic"
                        >
                            {selectedRole ? selectedRole : 'Select role'}
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="Duration-drop-down">
                            {role?.map((item: any, index: any) => {
                                return (
                                    <Dropdown.Item
                                        key={index}
                                        onClick={() => {
                                            console.log("ASdassd", editUserData?.userRole?.name, selectedRole, selectedManager, editUserData?.userRole?.id, CheckOldManagersAvailable(editUserData?.userRole?.id))
                                            if (editUserData && editUserData?.userRole?.name === 'Sales Executive' && (editUserData?.userRole?.name !== item?.name) && CheckOldManagersAvailable(3)) {
                                                showNotification({
                                                    type: 'info',
                                                    title: 'Please remove the reporting managers before changing the role',
                                                });
                                            }
                                            else if (editUserData && editUserData?.userRole?.name === 'Sales Manager' && (editUserData?.userRole?.name !== item?.name) && CheckOldManagersAvailable(4)) {
                                                showNotification({
                                                    type: 'info',
                                                    title: 'Please remove the reporting managers before changing the role',
                                                });
                                            } else {
                                                setSelectedRole(item.name)
                                                getManagerList(item.id);
                                                userData.userRoleId = item.id;
                                                setUserData({ ...userData })
                                            }

                                        }}
                                        eventKey={item.name}
                                    >
                                        <div className="menu-item-minutes">{item.name}</div>
                                    </Dropdown.Item>
                                );
                            })}
                        </Dropdown.Menu>
                    </Dropdown>

                    {selectedRole && (selectedRole === 'Sales Manager' || selectedRole === 'Sales Executive' || selectedRole === 'Sales Head') &&
                        <div className={`${selectedRole === 'Sales Manager' && editUserData ? 'change-display' : ''}`}>
                            {selectedRole !== 'Sales Head' && <div className="user-container mt-5">

                                <h1 className='mb-2'>
                                    Assign {selectedRole === 'Sales Manager' ? 'Head' : 'Manager'}<span></span>
                                </h1>
                                <div className='user-first-last-div petsked-form'>
                                    <ReactSelect
                                        className={`multiselect-react ${selectedRole === 'Sales Manager' && editUserData ? 'filter-fixed-width' : 'w-full'}`}
                                        options={managers ? managers : []}
                                        isMulti={true}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        classNamePrefix={'petsked-multiselect'}
                                        onChange={(selected: any) => {
                                            setSelectedManager(selected);
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        components={{
                                            Option: Option1,
                                            ValueContainer: ValueContainer1,
                                        }}
                                        placeholder={'Select managers'}
                                        value={selectedManager}
                                        isDisabled={!selectedRole}
                                    />
                                </div>

                                <SelectedManagers
                                    removeProvider={removeProvider}
                                    selectedServiceProviders={selectedManager}
                                />
                            </div>}

                            {selectedSubords && selectedSubords?.length > 0 && <div className="user-container mt-5">

                                <h1 className='mb-2'>
                                    Assign {selectedRole === 'Sales Head' ? 'Manager' : 'Executive'}<span></span>
                                </h1>
                                <div className='user-first-last-div petsked-form'>
                                    <ReactSelect
                                        className={`multiselect-react ${selectedRole === 'Sales Manager' && editUserData ? 'filter-fixed-width' : 'w-full'}`}
                                        options={selectedSubords ? selectedSubords : []}
                                        isMulti={true}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        classNamePrefix={'petsked-multiselect'}
                                        onChange={(selected: any) => {
                                            // setSelectedManager(selected);
                                        }}
                                        getOptionLabel={(option) => option.name}
                                        getOptionValue={(option) => option.id}
                                        components={{
                                            Option: Option1,
                                            ValueContainer: ValueContainer1,
                                        }}
                                        placeholder={'Select managers'}
                                        value={selectedSubords}
                                        isDisabled={!selectedRole}
                                    />
                                </div>

                                <SelectedManagers
                                    removeProvider={removeProvider1}
                                    selectedServiceProviders={selectedSubords}
                                />
                            </div>}
                        </div>}
                </div>
                {selectedRole && (selectedRole === 'Sales Manager' || selectedRole === 'Sales Executive' || selectedRole === 'Sales Head') && <div className="user-container mt-5">

                    <h1 className='mb-2'>
                        Location Details<span>*</span>
                    </h1>
                    <div className='loctaion-title'>
                        <div className='title'>
                            <h2 className='mb-2'>
                                Location<span></span>
                            </h2>
                        </div>
                        <div className='addd-location' onClick={() => { addCityAndState() }}>
                            <img src={AddWhiteIcon} />
                        </div>
                    </div>



                    <div className="title">
                        <div className="user-first-last-div iscity-drp petsked-form mb-3">
                            {states && states.length > 0 &&

                                <ReactSelect
                                    className="multiselect-react filter-height filter-fixed-width mt-2"
                                    options={states ? states : []}
                                    isMulti={false}
                                    closeMenuOnSelect={true}
                                    hideSelectedOptions={false}
                                    classNamePrefix={'petsked-multiselect'}
                                    onChange={(selected: any) => {
                                        locationDetails.state = selected.name
                                        locationDetails.stateId = selected.id
                                        setLocationDetails({ ...locationDetails })
                                        setCity([]);
                                        setSelectedCity([]);
                                        getCityList(selected.id);
                                    }}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    components={{
                                        // Option :Option2,
                                        //ValueContainer : ValueContainer2,
                                    }}
                                    placeholder={'Assign state'}
                                    value={locationDetails.state ? locationDetails.state.name : 'Assign state'}

                                />
                            }
                            {/* <Dropdown className="new-figma-drop-down">
                                <Dropdown.Toggle
                                    variant="success"
                                    className="drop-down-btn fixed-width-half dropdown-toggle"
                                    id="dropdown-basic"
                                >
                                    {locationDetails && locationDetails.state.trim() !== '' ? locationDetails?.state : 'Assign state'}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="Duration-drop-down">
                                    {states?.map((item: any, index: any) => {
                                        return (
                                            <Dropdown.Item
                                                key={index}
                                                onClick={() => {
                                                    locationDetails.state = item.name
                                                    locationDetails.stateId = item.id
                                                    setLocationDetails({ ...locationDetails })
                                                    setCity([]);
                                                    setSelectedCity([]);
                                                    getCityList(item.id);
                                                }}
                                                eventKey={item.name}
                                            >
                                                <div className="menu-item-minutes">{item.name}</div>
                                            </Dropdown.Item>
                                        );
                                    })}
                                </Dropdown.Menu>
                            </Dropdown> */}
                            <ReactSelect
                                className="multiselect-react mt-1"
                                options={city ? city : []}
                                isMulti={true}
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                classNamePrefix={'petsked-multiselect'}
                                onChange={(selected: any) => {
                                    setSelectedCity(selected);
                                }}
                                getOptionLabel={(option) => option.name}
                                getOptionValue={(option) => option.id}
                                components={{
                                    Option,
                                    ValueContainer,
                                }}
                                placeholder={'Assign city'}
                                value={selectedCity}
                            //isDisabled={locationDetails.state.trim() === ''}

                            />
                        </div>
                        {/* {selectedLocationDetails && selectedLocationDetails.length>0 && <div className='seletcted-location'>Selected locations</div>} */}

                        {selectedLocationDetails &&
                            selectedLocationDetails
                                .sort((a: any, b: any) => a.state.localeCompare(b.state)) // Sort states alphabetically
                                .map((item: any, index: number) => {
                                    return (
                                        <>
                                            <div key={index} className={`selected-location-details`}>
                                                <div className="state">
                                                    {item.state}{" "}
                                                    <span onClick={() => { deleteState(item.state); }}>
                                                        <img src={CloseIcon} className="icon" />
                                                    </span>
                                                </div>
                                                <div className="state remove-bg">
                                                    <img src={ArrowIcon} />
                                                </div>
                                                <div className="city">
                                                    {item.city
                                                        .sort((a: any, b: any) => a.name.localeCompare(b.name)) // Sort cities alphabetically
                                                        .map((city: any) => {
                                                            return (
                                                                <div className="city-name" key={city.id}>
                                                                    {city.name}{" "}
                                                                    <span onClick={() => { deleteCity(city.id); }}>
                                                                        <img src={CloseIcon} className="icon" />
                                                                    </span>
                                                                </div>
                                                            );
                                                        })}
                                                </div>
                                            </div>
                                        </>
                                    );
                                })}

                    </div>



                </div>}



            </div>
        );
    };
    return (
        <>
            <Modal
                show={open}
                onHide={() => { resetStates(), onClose() }}
                className={`steam-modal-dialog add-user-modal `}
                size="sm"

            >
                <Modal.Header closeButton >
                    <div className="model-header-tab">
                        <div className="modal-header-title">
                            {editUserData ? "Edit user" : 'Add new user'}
                        </div>
                        <div className="modal-header-desc">
                            {/* {'Lorem ipsum dolor sit amet, consectetur elit, sed'} */}
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body >{getContent()}</Modal.Body>
                <ModalFooter>
                    <div className={`btn-container end`}>
                        <button
                            className={`steam-button button-dark set-height-1`}
                            onClick={async () => {
                                const transformedLocations = selectedLocationDetails && selectedLocationDetails.length > 0 && selectedLocationDetails.map(location => ({
                                    stateId: Number(location.stateId),
                                    cityId: location.city.map((city: any) => Number(city.id))
                                }));

                                const transformedManager = selectedManager && selectedManager.length > 0
                                    ? selectedManager.map(manager => Number(manager.id))
                                    : [];

                                const getRoleID = role.find((item: any) => item.name === selectedRole);
                                if (validate()) {
                                    const isSeniors = (selectedRole === 'Sales Manager' || selectedRole === 'Sales Executive') ? true : false
                                    await useUserMutations.mutateAsync({
                                        id: editUserData ? Number(editUserData?.id) : undefined,
                                        name: userData.name,
                                        email: userData.email,
                                        phone: phone?.startsWith('+') ? phone : `+${phone}`,
                                        location: transformedLocations,
                                        userRoleId: Number(getRoleID.id),
                                        seniorIds: isSeniors ? transformedManager : []
                                    });
                                    if (editUserData && editUserData.id) {
                                        showNotification({
                                            type: 'success',
                                            title: 'User Edited Succesfully',
                                        });
                                    } else {
                                        showNotification({
                                            type: 'success',
                                            title: 'User Added Successfully',
                                        });
                                    }

                                    resetStates(),
                                        onConfirm();
                                }
                            }}
                        //disabled={useAddInstituteMutation?.isLoading}
                        >
                            <span>{editUserData ? "Save" : 'Add User'}</span>
                        </button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    );
};

const Option1 = (props: any) => {
    const {
        data: { avatarUrl, name, email },
    } = props;
    return (
        <div key={`options-sp${props.value}`}>
            <components.Option {...props}>
                <div className="service-provider-option full">
                    <div className="left-details">
                        {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
                        <span>
                            <label className="name">{name}</label>
                            {/* <label className="email">{email}</label> */}
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};

const Option = (props: any) => {
    const {
        data: { avatarUrl, name, email },
    } = props;
    return (
        <div key={`options-sp${props.value}`}>
            <components.Option {...props}>
                <div className="service-provider-option">
                    <div className="left-details">
                        {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
                        <span>
                            <label className="name">{name}</label>
                            {/* <label className="email">{email}</label> */}
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};
const ValueContainer = (props: any) => {
    const valueLength = props.getValue().length;
    return (
        <components.ValueContainer {...props}>
            {valueLength === 0 && <span className="react-select-custom-placeholder">Select city</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength} added`}
            {React.Children.map(props.children, (child) => {
                if (child) {
                    return child.type === components.Input ? child : null;
                }
            })}
        </components.ValueContainer>
    );
};


const ValueContainer1 = (props: any) => {
    const valueLength = props.getValue().length;
    return (
        <components.ValueContainer {...props}>
            {valueLength === 0 && <span className="react-select-custom-placeholder">Select seniors</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength} added`}
            {React.Children.map(props.children, (child) => {
                return child.type === components.Input ? child : null;
            })}
        </components.ValueContainer>
    );
};


const Option2 = (props: any) => {
    const {
        data: { avatarUrl, name, email },
    } = props;
    return (
        <div key={`options-sp${props.value}`}>
            <components.Option {...props}>
                <div className="service-provider-option">
                    <div className="left-details">
                        {/* <img className="rounded-full border-0" src={avatarUrl} referrerPolicy="no-referrer" /> */}
                        <span>
                            <label className="name">{name}</label>
                            {/* <label className="email">{email}</label> */}
                        </span>
                    </div>
                    <div>
                        <label htmlFor={`option-check-${props.value}`} className="check-container">
                            <input checked={props.isSelected} id={`option-check-${props.value}`} type="checkbox" />
                            <span className="checkmark"></span>
                        </label>
                    </div>
                </div>
            </components.Option>
        </div>
    );
};
const ValueContainer2 = (props: any) => {
    const valueLength = props.getValue().length;
    return (
        <components.ValueContainer {...props}>
            {valueLength === 0 && <span className="react-select-custom-placeholder">Select state</span>}
            {props.getValue().length > 0 &&
                !props.selectProps.inputValue &&
                `+${valueLength} added`}
            {React.Children.map(props.children, (child) => {
                if (child) {
                    return child.type === components.Input ? child : null;
                }
            })}
        </components.ValueContainer>
    );
};



export default AddNewUser;
